import React from "react"
import GambleButton from "./GambleButton"
import { SUITS } from "./helperFunctions/getButton"
import { GAMBLE_BUTTON_PROPS } from "./interface"
import { ActionsContainer } from "./GambleComponentsStyled"
// import loseSFX from "../../../../assets/audio/loseSFX.mp3";
// import winSFX from "../../../../assets/audio/winSFX1.mp3";
// import useSound from "use-sound";

export default function GambleActions({
  sendSocketMessage,
  setChangeCard,
  showGambleResult,
  card,
  stateRound,
  audioUrl,
  cashout,
  handleCashout,
}: GAMBLE_BUTTON_PROPS) {
  const { wincoef } = stateRound

  return (
    <ActionsContainer winamount={wincoef > 0}>
      {showGambleResult && card !== "X0" && (
        <p className="result"> Win {wincoef.toFixed(2)} X</p> //this is multiplier, no need to use precision
      )}
      <h3>color pays 2x</h3>
      <GambleButton
        suits={SUITS}
        sliceA={0}
        sliceB={2}
        setChangeCard={setChangeCard}
        sendSocketMessage={sendSocketMessage}
        stateRound={stateRound}
        audioUrl={audioUrl}
        cashout={cashout}
        handleCashout={handleCashout}
      />
      <h3>suit pays 4x</h3>
      <GambleButton
        suits={SUITS}
        sliceA={2}
        sliceB={SUITS.length}
        setChangeCard={setChangeCard}
        sendSocketMessage={sendSocketMessage}
        stateRound={stateRound}
        audioUrl={audioUrl}
        cashout={cashout}
        handleCashout={handleCashout}
      />
    </ActionsContainer>
  )
}
